import { gql } from '../../../apollo/__generated__';

export const EVENT_BEDROOMS = gql(`
  query EventBedrooms($eventId: ID!) {
    eventBedrooms(eventId: $eventId) {
      id
      floor
      doorNumber
      maxUsers
      users(eventId: $eventId) {
        id
        firstname
        lastname
        nickname
        studyTown
      }
    }
  }
`);
